namespace RioERP.Orders {
    export interface OrderWebhookRow {
        Id?: number;
        SiteName?: string;
        ErrorNote?: string;
        OrderId?: number;
        Orderguid?: string;
        IsSynced?: boolean;
        hasError?: boolean;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace OrderWebhookRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SiteName';
        export const localTextPrefix = 'Orders.OrderWebhook';
        export const deletePermission = 'Orders:OrdersManagement:Modify|Orders:FranchiseeOrdersManagement:View';
        export const insertPermission = 'Orders:OrdersManagement:Modify|Orders:FranchiseeOrdersManagement:View';
        export const readPermission = 'Orders:OrdersManagement:View|Orders:FranchiseeOrdersManagement:View';
        export const updatePermission = 'Orders:OrdersManagement:Modify|Orders:FranchiseeOrdersManagement:View';

        export declare const enum Fields {
            Id = "Id",
            SiteName = "SiteName",
            ErrorNote = "ErrorNote",
            OrderId = "OrderId",
            Orderguid = "Orderguid",
            IsSynced = "IsSynced",
            hasError = "hasError",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
